import { DATE_TIME_FORM_ADD_CHANGE, RESET_DATE_TIME_FORM} from  '../redux/reducers/dateTime'

export const  dateTimeFormChange = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: DATE_TIME_FORM_ADD_CHANGE, ...data})
    }
};


export const dateTimeFormReset = () => {
    return (dispatch: any) => {
        return dispatch({type: RESET_DATE_TIME_FORM})
    }
};


